import FigureDisplay from "./FigureDisplay";

export default FigureDisplay;